export const experienceData = [
    {
        id: 1,
        company: 'Cybercom',
        jobtitle: 'Software Engineer',
        startYear: 'June-2026',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'PITB(Digital Scrap)',
        jobtitle: 'Full Time Software Engineer',
        startYear: 'January-2025',
        endYear: 'July-2024'
    },
    {
        id: 3,
        company: 'Digital Scrap',
        jobtitle: 'Software Engineer Intern',
        startYear: 'May-2024',
        endYear: 'July-2024'
    },
    {
        id: 4,
        company: 'PMAS Arid Agriculture University Rawalpindi',
        jobtitle: 'Web Developer',
        startYear: '2023',
        endYear: '2024'
    },
]